export default __webpack_public_path__ + "static/media/agent_active.3b1fdc37.svg";